import Vue from 'vue'
import App from './App.vue'

Vue.prototype.$URL = 'https://election-calc.online/hmr/server/api.php';

Vue.prototype.$http = axios;
import 'bootstrap/dist/css/bootstrap.css'
import 'animate.css';
import axios from 'axios'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
